import { createAction } from 'typesafe-actions'
import { IPageData } from '../Types/IPageData'

export const setPageData = createAction('page-setPageData')<IPageData>()
